"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var deep_equal_extended_1 = require("deep-equal-extended");

var UniqueBehaviorSubject = /*#__PURE__*/function (_rxjs_1$BehaviorSubje) {
  _inherits(UniqueBehaviorSubject, _rxjs_1$BehaviorSubje);

  var _super = _createSuper(UniqueBehaviorSubject);

  function UniqueBehaviorSubject() {
    var _this;

    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UniqueBehaviorSubject);

    _this = _super.call(this, options.prepare ? options.prepare(value, null) : value);

    var next = _this.next.bind(_assertThisInitialized(_this));

    _this.next = function (value) {
      var isEqual = false;

      if (options.prepare) {
        value = options.prepare(value, _this.value);
      }

      if (options.compare) {
        isEqual = options.compare(value, _this.value);
      } else {
        isEqual = UniqueBehaviorSubject.defaultCompare(value, _this.value);
      }

      if (!isEqual) {
        next(value);
      }
    };

    return _this;
  }

  return UniqueBehaviorSubject;
}(rxjs_1.BehaviorSubject);

UniqueBehaviorSubject.defaultCompare = deep_equal_extended_1.deepEqual;
exports.UniqueBehaviorSubject = UniqueBehaviorSubject;